"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const divisions = [{
  name: "Kalisch Steel",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/logo_kalisch_steel.png",
  url: "/KalischSteelPage"
}, {
  name: "Besthal",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/logo_besthal.png",
  url: "#"
}, {
  name: "Box Tool",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/logo_box_tool.png",
  url: "#"
}, {
  name: "Faber",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/logo_faber.png",
  url: "#"
}];
export default function BusinessDivisions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}